import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import ChooseProjectForm from './chooseProjectForm/ChooseProjectForm';
import SignInForm from './signInForm/SignInForm';
import MainPageContainer from './../../components/MainPageContainer';
import SetInitialPassword from '../setInitialPassword/SetInitialPassword';

const FormWrapper = styled.div`
  min-height: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export class SignIn extends React.Component {

  render() {
    const {
      isSignedIn,
      initialPasswordChanged
    } = this.props;
    return (
      <MainPageContainer
        withBackLink={false}>
        <FormWrapper>
          {(isSignedIn !== "true")
            ? <SignInForm />
            : (initialPasswordChanged 
              ? <ChooseProjectForm />
              : <SetInitialPassword />)
          }
        </FormWrapper>
      </MainPageContainer >
    );
  }
};

const mapStateToProps = state => ({
  initialPasswordChanged: state.auth.get('initialPasswordChanged'),
  isSignedIn: state.auth.get('isSignedIn')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(SignIn));


// WEBPACK FOOTER //
// ./src/containers/signIn/SignIn.jsx